import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { CondicaoPagamentoRequest, SimularParcelasRequest, Response } from './Types';

class CondicaoPagamentoController {
  public static async Listar(
    request: CondicaoPagamentoRequest
  ): Promise<Response> {
    try {
      console.log('Controller Condicao Pagamento Listar');
      console.log(request);

      const response = await Api.post(`api/condicaopagamento/Listar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async SimularParcelas(
    request: SimularParcelasRequest
  ): Promise<Response> {
    try {
      const response = await Api.post(
        `api/condicaopagamento/SimularParcelas`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(
    condicaopagamentoId: number
  ): Promise<Response> {
    try {
      console.log('Controller CondicaoPagamento Listar Unico');
      console.log(condicaopagamentoId);

      const response = await Api.get(
        `api/condicaopagamento/ListarUnico/${condicaopagamentoId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(
    request: CondicaoPagamentoRequest
  ): Promise<Response> {
    try {
      console.log('Controller CondicaoPagamento Adicionar');
      console.log(request);

      const response = await Api.post(
        `api/condicaopagamento/Adicionar`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(
    request: CondicaoPagamentoRequest
  ): Promise<Response> {
    try {
      console.log('Controller Condicao Pagamento Atualizar');
      console.log(request);

      const response = await Api.put(
        `api/condicaopagamento/Atualizar`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(
    request: CondicaoPagamentoRequest
  ): Promise<Response> {
    try {
      console.log('Controller Condicao Pagamento Excluir');
      console.log(request);

      const response = await Api.put(`api/condicaopagamento/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default CondicaoPagamentoController;
